
<template lang="pug">
  span.eui-live-bullet
    IconLiveBullet
</template>


<script>
import IconLiveBullet from '../../assets/icon-live-bullet.svg';

export default {
  name: 'liveBullet',
  components: {
    IconLiveBullet
  }
};

</script>

<style lang="scss">

@keyframes liveOpacity {
	0% { opacity: 1; }
	60% { opacity: 1; }
	100% { opacity: 0; }
}

.eui-live-bullet {
  width: 20px;
  height: 20px;

  svg {
    width: 100%;
    height: auto;
    .eui-svg-icon_ellipse {
      animation: liveOpacity 1s infinite ease-out alternate;
    }
  }
}

</style>
